function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function setCookie(name,value) {
  document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * 14};`;
}

function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  } else {
    return false;
  }
}

function isMobile() {
  const smallScreen = window.matchMedia("only screen and (max-width: 749px)").matches;
  const mobileDevice = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  const isMobile = smallScreen || mobileDevice;
  return isMobile;
}

function deleteCookie(name) { setCookie(name, '', 0); }

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


var Shopify=Shopify||{};Shopify.money_format="${{amount}}",Shopify.formatMoney=function(a,o){"string"==typeof a&&(a=a.replace(".",""));var e="",t=/\{\{\s*(\w+)\s*\}\}/,o=o||this.money_format;function r(a,o){return void 0===a?o:a}function n(a,o,e,t){if(o=r(o,2),e=r(e,","),t=r(t,"."),isNaN(a)||null==a)return 0;a=(a=(a/100).toFixed(o)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?t+a[1]:"")}switch(o.match(t)[1]){case"amount":e=n(a,2);break;case"amount_no_decimals":e=n(a,0);break;case"amount_with_comma_separator":e=n(a,2,".",",");break;case"amount_no_decimals_with_comma_separator":e=n(a,0,".",",")}return o.replace(t,e)};

var theme = theme || {};

theme.addItem = function (v, q, p) {
  q = q || 1;
  p = p || "";
  const formData = {
    items: [
      {
        id: v,
        quantity: q
      }
    ],
  };
  if(p != '') {
    formData.items[0].properties = p;
  }
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    theme.addToCartOk(data);
  })
  .catch((error) => {
    console.error("Error:", error);
  });
};

theme.removeItem = function(v) {
  const formData = {
    id: v.toString(),
    quantity: 0
  };
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    theme.updateCart(data);
  })
  
  .catch((error) => {
    console.error("Error:", error);
  });
  
};

var theme = theme || {};

theme.replaceElements = function (arr, data) {
  arr.forEach(function (el, i) {
    document.querySelector(el).innerHTML = data.querySelector(el).innerHTML;
  });
};

theme.updateCart = function (open = false) {
  fetch("/?section_id=cart-drawer")
  .then(function (response) {
    return response.text();
  })
  .then(function (html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const cartReplacements = ["#cart-drawer .drawer__content"];
    theme.replaceElements(cartReplacements, doc);
    
    theme.checkGWP();
    if (open) {
      theme.openCartDrawer();
    }
  })
  .finally(() => {
   // theme.insurance();
  })
  .catch(function (err) {
    console.warn("Something went wrong.", err);
  });
};

theme.updateURL = function (url) {
  window.history.replaceState({}, "", url);
};

theme.cartDrawerLayout = function() {
  const h = document.querySelector('.cart-drawer__header').offsetHeight;
  document.querySelector('.cart-drawer__main').style.paddingTop = h + 'px';
  
}

theme.openCartDrawer = function () {
  document.querySelector("body").classList.add("overflow-hidden");
  const cartDrawer = document.querySelector(".cart-drawer");
  const checkoutBtn = document.querySelector(".cart__checkout-button");
  cartDrawer.classList.add("is--open");
  cartDrawer.setAttribute("aria-hidden", false);
  cartDrawer.setAttribute("tabindex", "0");
  trapFocus(cartDrawer, checkoutBtn);
//   theme.wearWith();
  theme.scrollAnimations();
  theme.cartDrawerLayout();
};

theme.closeCartDrawer = function () {
  document.querySelector("body").classList.remove("overflow-hidden");
  const cartDrawer = document.querySelector(".cart-drawer");
  cartDrawer.querySelectorAll('.cart-item').forEach(cartItem => {
    cartItem.classList.remove('inview');
  });
  cartDrawer.classList.remove("is--open");
  cartDrawer.setAttribute("aria-hidden", true);
  cartDrawer.setAttribute("tabindex", "-1");
};

theme.addToCartOk = function (c) {
  theme.updateCart(true);
};

theme.quickAdd = function () {
  const quickAddRadios = document.querySelectorAll(".quick-add__radio input");
  quickAddRadios.forEach((el) => {
    el.addEventListener("change", function (e) {
      e.preventDefault();
      const productCard = el.closest(".card-wrapper");
      const selected = productCard.querySelectorAll("input:checked");
      const selectedMap = Array.from(selected)
        .map((el) => el.value)
        .join(" / ");
      
      const json = JSON.parse(
        productCard.querySelector(".card--product").dataset.variants
      );
      const preOrderInfo = productCard.querySelector('.card--product').dataset.preOrderInfo.split(',');
      let props = {};
      const propertyInputs = productCard.querySelectorAll('.product-input__property');
      propertyInputs.forEach((input) => {
        const inputName = input.getAttribute('data-name');
        props[inputName] = input.value;
      });
      
      let i = 0;
      json.forEach((variant) => {
        if (variant.title === selectedMap) {
          if(preOrderInfo[i] !== '') {
            props['Note'] = preOrderInfo[i];
          }
          theme.addItem(variant.id,1,props);
        }
        i++;
      });
    });
  });
};

theme.hasInsurance = function() {
  const insuranceProductId = 6791858127001;
  const cartJson = JSON.parse(document.querySelector('#cart-drawer .drawer__items').getAttribute('data-json'));
  let insuranceInCart = false;
  cartJson.forEach(item => {
    if(item.product_id == insuranceProductId) {
      insuranceInCart = item.id;
    }
  });
  console.log(cartJson);
  return insuranceInCart;
}

theme.removeInsurance = function() {

  let updateData = {
    updates: {}
  };

  let variantId = theme.hasInsurance();

  updateData.updates[variantId] = 0;

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updateData),
  })
  .then((data) => {
    return data.json();
  })
  .then((response) => {
    theme.updateCart();

  });
};

//theme.insurance = function() {
//  
//  const insuranceButton = document.querySelector('.rw-checkbox-span');
//  
//  document.querySelector('.rw-checkbox-span').addEventListener('click',(e) => {
//    e.preventDefault();
//    if(theme.hasInsurance()) {
//      setCookie('_insurance','no-thanks');
//      theme.removeInsurance();
//    } else {
//      deleteCookie('_insurance');
//      theme.insurance();
//    }
//    e.target.classList.toggle('rw-checked');
//    e.target.classList.toggle('rw-unchecked');
//  });
//
//  let insuranceProductId = 6791858127001,
//        cartJson = JSON.parse(document.querySelector('#cart-drawer .drawer__items').getAttribute('data-json')),
//        cartTotal = parseFloat(document.querySelector('#cart-drawer .drawer__items').getAttribute('data-cart-total')),
//        insuranceCookie = getCookie('_insurance'),
//        hasInsuranceProduct = false,
//        currentInsuranceVariant = false,
//        insuranceVariant = window.insuranceVariants[0];
//
//  cartJson.forEach(item => {
//    if(item.product_id == insuranceProductId) {
//      hasInsuranceProduct = true;
//      currentInsuranceVariant = item;
//    }
//  });
//  
//  window.insuranceVariants.forEach(variant => {
//    let insurancePrice = variant.price * 100.00;
//    if(cartTotal > insurancePrice) {
//      insuranceVariant = variant;
//    }
//  });
//  
//  let insurancePrice = insuranceVariant.price / 100;
//  insurancePrice = insurancePrice.toLocaleString("en-US", {style:"currency", currency:"USD"});
//  document.querySelector('.ppp-amount').textContent = insurancePrice;
//  
//  if(cartJson.length == 0) return;
//  if(insuranceCookie == 'no-thanks') {
//    insuranceButton.classList.remove('rw-checked');
//    return false;
//  } 
//  
//  if(!hasInsuranceProduct) {
//	insuranceButton.classList.remove('rw-checked');
//    theme.addItem(insuranceVariant.id,1);
//    
//  } else {
//    if(currentInsuranceVariant.id != insuranceVariant.id) {
//      let updateData = {
//        updates: {}
//      };
//      updateData.updates[currentInsuranceVariant.id] = 0;
//      updateData.updates[insuranceVariant.id] = 1;
//      
//      fetch('/cart/update.js', {
//        method: 'POST',
//        credentials: 'same-origin',
//        headers: {
//          'Content-Type': 'application/json',
//        },
//        body: JSON.stringify(updateData),
//      })
//      .then((data) => {
//        return data.json();
//      })
//      .then((response) => {
//        theme.updateCart();
//        
//      });
//    }
//  }
//    
//};

theme.footerAccordion = function() {
  const footerAccordtionTriggers = document.querySelectorAll('.footer-heading__trigger');
  const footerAccordionPanels = document.querySelectorAll('.footer-block__linklist');
  footerAccordtionTriggers.forEach(trigger => {
    trigger.addEventListener('click',e => {
      
      const myPanel = document.querySelector('#'+e.target.getAttribute('aria-controls'));
      
      
      if(!myPanel) return;
      
      const expanded = e.target.getAttribute('aria-expanded');
      

      
      if(expanded == "true") {
        
        
        e.target.parentNode.classList.remove('active');
        e.target.setAttribute('aria-expanded',"false");
        myPanel.classList.add('hidden');
        
      } else {
        
        footerAccordionPanels.forEach(panel => {
          panel.classList.add('hidden');
          panel.style.display = 'block';
        });

        footerAccordtionTriggers.forEach(t => {
          t.setAttribute('aria-expanded',"false");
        });

        e.target.parentNode.classList.add('active');
        e.target.setAttribute('aria-expanded',"true");
        myPanel.classList.remove('hidden');
        
      }
      
      
      
    });
  });
};

/* lazy enchancement */

theme.lazyImages = function() {
  if ('loading' in HTMLImageElement.prototype) {    
    var lazyImages = document.querySelectorAll('.lazyImage img');
      
    for (var img of lazyImages) {
      if (!img.complete) {
        img.parentNode.classList.add('lazyImageWaiting');
        //img.addEventListener('load', lazyImageLoad, false);
        img.addEventListener('load', lazyImageLoad(img), false);
        img.addEventListener('error', lazyImageError, false);
      }
    }
    
    function lazyImageLoad(e) {
      setTimeout(function() {
        console.log(e.target);
        //var el = e.target.parentNode ? e.target.parentNode : e.target;
        var el = e.parentElement ? e.parentElement : e;
        
        el.classList.remove('lazyImageWaiting');
        el.classList.add('loaded');

      }, 100);
    }
    
    function lazyImageError(e) {
      var parent = e.currentTarget.parentNode;
      parent.classList.remove('lazyImageWaiting');
      parent.classList.add('lazyImageError');
      setTimeout(function() {
        parent.classList.add('lazyImageErrorShow');
      }, 60);
    }
    
  } // if 'loading' supported
  
};

theme.forceLazies = function() {
  var lazyImages = document.querySelectorAll('.lazyImage');
  lazyImages.forEach(lazyImage => {
    lazyImage.classList.remove('lazyImage');
  });
}
  

document.addEventListener("DOMContentLoaded", (e) => {
 // theme.insurance();
  theme.lazyImages();
  const insuranceCheckbox = document.querySelector('.rw-checkbox-span');
  theme.footerAccordion();
});

document.addEventListener("shopify:section:load", function(event) {
  theme.forceLazies();
});

// js for accessibility dialog open by Nishid
document.addEventListener("DOMContentLoaded", function() {
  let acc_btn = document.querySelector(".acsb-custom-trigger");
  let listenerAdded = false;
  const observer = new MutationObserver(function(mutationsList, observer) {
    mutationsList.forEach(function(mutation) {
      if (mutation.type === "childList") {
        let widget_button = document.getElementById("accessiblyAppDialogButton");
        if (widget_button && !listenerAdded) {
          if (acc_btn) {
            acc_btn.addEventListener("click", function(event) {
              event.preventDefault();
              widget_button.click();
            });
          } else {
            console.log("acc_btn not found!");
          }
          listenerAdded = true;
          observer.disconnect();
        }
      }
    });
  });
  // Start observing the body for changes in child nodes
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  // Function to sync and enable buttons
  const syncAndEnableButton = (bottomSelector, topSelector) => {
    const bottomButton = document.querySelector(bottomSelector);
    const topButton = document.querySelector(topSelector);

    if (bottomButton && topButton) {
      bottomButton.removeAttribute("disabled"); // Enable the bottom button
      bottomButton.addEventListener("click", () => topButton.click()); // Sync click event
    }
  };

  // Function to wait for buttons to load
  const waitForButtons = () => {
    const interval = setInterval(() => {
      const bottomNext = document.querySelector(".slider-button--next-bottom");
      const topNext = document.querySelector(".slider-button--next-top");
      const bottomPrev = document.querySelector(".slider-button--prev-bottom");
      const topPrev = document.querySelector(".slider-button--prev-top");

      // Check if all buttons are present
      if (bottomNext && topNext && bottomPrev && topPrev) {
        syncAndEnableButton(".slider-button--next-bottom", ".slider-button--next-top");
        syncAndEnableButton(".slider-button--prev-bottom", ".slider-button--prev-top");
        clearInterval(interval); // Stop checking once buttons are found
      }
    }, 100); // Check every 100ms
  };

  // Call the waitForButtons function
  waitForButtons();
});


